import { useMutation, useQueryClient } from 'react-query'
import { createProject } from 'api/services'

export const useCreateProject = (options = {}) => {
  const queryClient = useQueryClient()
  const { onSuccess = () => {} } = options

  return useMutation(createProject, {
    ...options,
    onSuccess: (data) => {
      queryClient.invalidateQueries('projects')
      onSuccess(data)
    },
  })
}
